export const SALON_PAYMENT_METHODS = [
  { value: 'PIX', label: 'PIX' },
  { value: 'DEBIT_CARD', label: 'Cartão de débito' },
  { value: 'CREDIT_CARD', label: 'Cartão de crédito' },
  { value: 'CASH', label: 'Dinheiro' },
];

export const salonPaymentMethodLabel = (method) => (
  SALON_PAYMENT_METHODS.find((item) => item.value === method)?.label || method || 'Não informada'
);

export const getSalonPaymentRequest = (session = {}) => {
  const request = session?.paymentRequest && typeof session.paymentRequest === 'object'
    ? session.paymentRequest
    : null;
  if (!request) return null;
  return {
    ...request,
    status: request.status || session.paymentRequestStatus || '',
    reviewReason: request.reviewReason || request.correctionReason || '',
  };
};

export const isSalonPaymentAwaitingCashier = (session = {}) => {
  const request = getSalonPaymentRequest(session);
  return Boolean(request?.requestId && request.status === 'submitted');
};

export const isSalonPaymentCorrectionNeeded = (session = {}) => {
  const request = getSalonPaymentRequest(session);
  return Boolean(request?.requestId && request.status === 'needs_correction');
};

export const sortSalonTablesForCashier = (tables = []) => (
  tables
    .map((table, index) => ({ table, index }))
    .sort((left, right) => {
      const leftPriority = isSalonPaymentAwaitingCashier(left.table?.activeSession) ? 0 : 1;
      const rightPriority = isSalonPaymentAwaitingCashier(right.table?.activeSession) ? 0 : 1;
      if (leftPriority !== rightPriority) return leftPriority - rightPriority;
      if (leftPriority === 0) {
        const leftRequest = getSalonPaymentRequest(left.table?.activeSession);
        const rightRequest = getSalonPaymentRequest(right.table?.activeSession);
        const leftAt = Date.parse(leftRequest?.submittedAt || leftRequest?.requestedAt || '') || Number.MAX_SAFE_INTEGER;
        const rightAt = Date.parse(rightRequest?.submittedAt || rightRequest?.requestedAt || '') || Number.MAX_SAFE_INTEGER;
        if (leftAt !== rightAt) return leftAt - rightAt;
      }
      return left.index - right.index;
    })
    .map(({ table }) => table)
);

export const getReadySalonItemIds = (tables = []) => {
  const ids = [];
  tables.forEach((table) => {
    (table?.activeSession?.items || []).forEach((item) => {
      if (item?.status !== 'ready') return;
      ids.push(String(item.id || item.orderId || `${table.id}-${item.name}-${item.readyAt || ''}`));
    });
  });
  return ids;
};

export const getSalonReadyCount = (table = {}) => (
  (table?.activeSession?.items || []).filter((item) => item?.status === 'ready').length
);

export const getSalonReadyOrderLabels = (tableOrSession = {}) => {
  const session = tableOrSession?.activeSession || tableOrSession;
  const seen = new Set();
  const labels = [];
  (session?.items || []).forEach((item) => {
    if (item?.status !== 'ready') return;
    const displayId = String(item.orderDisplayId || item.displayId || item.orderNumber || '').trim();
    const roundNumber = Number(item.roundNumber || 0);
    const key = String(item.orderId || displayId || (roundNumber ? `round:${roundNumber}` : item.id || '')).trim();
    if (!key || seen.has(key)) return;
    seen.add(key);
    if (displayId) labels.push(`Pedido #${displayId}`);
    else if (roundNumber) labels.push(`Rodada ${roundNumber}`);
  });
  return labels;
};

export const getSalonConsumptionItems = (session = {}) => (
  (session?.items || []).filter((item) => item?.status !== 'cancelled')
);

export const getSalonUndeliveredItems = (session = {}) => (
  (session?.items || []).filter((item) => ['pending', 'sent', 'ready'].includes(item?.status))
);
